/* eslint-disable camelcase */
import Vue from 'vue';
import hljs from 'highlight.js';
import 'highlight.js/styles/night-owl.css';
import { isEqual } from 'lodash';
import jsonSyntaxHighlighter from '../../utils/jsonSyntaxHighlighter';
import copyContentFromElementByIdIntoClipboard from '../../utils/clipboard/copyContentFromElementByIdIntoClipboard';
import getContentFromElementById from '../../utils/clipboard/getContentFromElementById';
import cleanCode from 'src/utils/ai/cleanCode';
Vue.use(hljs.vuePlugin);
export default Vue.extend({
    name: 'CodeRenderer',
    props: {
        code: { type: String, required: true },
        codeLanguage: { type: String, default: 'JSON' },
        callBackForSaving: { type: Function }
    },
    data() {
        return {
            code__ls: ''
        };
    },
    computed: {
        contenteditable() {
            return !!this.callBackForSaving;
        },
        codeEdited() {
            return !isEqual(this.code, this.code__ls);
        },
        highlightedJSON() {
            return jsonSyntaxHighlighter(this.code);
        }
    },
    watch: {
        code: {
            immediate: true,
            handler(newVal) {
                this.code__ls = newVal;
            }
        }
    },
    methods: {
        copy() {
            copyContentFromElementByIdIntoClipboard('area');
        },
        save() {
            const text = getContentFromElementById('area');
            if (this.callBackForSaving && text) {
                const text2 = cleanCode(text);
                debugger;
                this.callBackForSaving(text2, this.code);
            }
        }
    }
});
